var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15.8327H5.33333L12.5208 8.64518L11.3542 7.47852L4.16667 14.666V15.8327ZM16.0833 7.43685L12.5417 3.93685L13.7083 2.77018C14.0278 2.45074 14.4203 2.29102 14.8858 2.29102C15.3508 2.29102 15.7431 2.45074 16.0625 2.77018L17.2292 3.93685C17.5486 4.25629 17.7153 4.64185 17.7292 5.09352C17.7431 5.54463 17.5903 5.9299 17.2708 6.24935L16.0833 7.43685ZM3.33333 17.4993C3.09722 17.4993 2.89944 17.4193 2.74 17.2593C2.58 17.0999 2.5 16.9021 2.5 16.666V14.3118C2.5 14.2007 2.52083 14.0932 2.5625 13.9893C2.60417 13.8849 2.66667 13.791 2.75 13.7077L11.3333 5.12435L14.875 8.66602L6.29167 17.2493C6.20833 17.3327 6.11472 17.3952 6.01083 17.4368C5.90639 17.4785 5.79861 17.4993 5.6875 17.4993H3.33333ZM11.9375 8.06185L11.3542 7.47852L12.5208 8.64518L11.9375 8.06185Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.a8b53e43e9c13a7ebe17893646c0f7ca.svg";
export { ForwardRef as ReactComponent };